import { FunctionBrick, registerBrick, Auth } from 'olympe'

export default class GetUserToken extends FunctionBrick {
  /**
   * Executed every time an input () gets updated.
   * Note that this method will _not_ be executed if an input value is undefined.
   *
   * @protected
   * @param {BrickContext} context
   * @param {!Array} inputs
   * @param {function(string)} setToken
   */
  onUpdate(context, inputs, [setToken]) {
    setToken(Auth.getUserToken().nonce)
  }
}

registerBrick('017a7dfda438259560e9', GetUserToken)
